import { init } from "@nosto/preact"
import { Serp, Category, Autocomplete, History } from "./components"
import { defaultConfig } from "./config"

import "./styles/index.css"

init({
    ...window.nostoTemplatesConfig,
    serpComponent: Serp,
    // historyComponent: History,
    autocompleteComponent: Autocomplete,
    categoryComponent: Category,
    // inputCssSelector: "#bc-sf-search-box-0",
    inputCssSelector: ".header-search__input",

    // contentCssSelector: "#main .CollectionMain",
    contentCssSelector: "#NostoTargetSearch",
    
    
    serpUrlMapping: {
        query: "q",
        "products.filter": "filter",
        "products.page": "page",
        "products.sort": "sort"
    },
    // Uncomment to redirect to search page instead of rendering on the same page
    serpPath: '/search',

    // Uncomment to redirect to search page instead of rewriting browser history
    serpPathRedirect: true,

    serpQuery: {
        products: {
            facets: ["*"],
            size: defaultConfig.serpSize,
            from: 0
        }
    },
    autocompleteQuery: {
        products: {
            size: defaultConfig.autocompleteProductsSize
        },
        keywords: {
            fields: ["keyword", "_highlight.keyword"],
            size: defaultConfig.autocompleteKeywordsSize,
            facets: ["*"]
        }
    },
    compressUrlParameters: true,
    fallback: true,

    // // Uncomment for Category Merchandising
    // categoryCssSelector: '.CollectionMain',
    categoryCssSelector: '#NostoTargetCollection',
       categoryQuery() {
        return {
            name: 'serp',
            products: {
                categoryId: this.categoryId(),
                categoryPath: this.categoryPath(),
                size: defaultConfig.serpSize,
                from: 0,
            }
        }
    },
})
